<template>
  <div class="h-f bg-00903B-C0DECC">
    <el-aside class="" width="100%">

      <!-- 关于我们 -->
      <div class="w360 px10 pt24 pb25" v-if="current==1">
        <div class="ft24 c-w font-Bold">
          {{ $t('关于我们') }}
        </div>
        <div class="mt18">
          <el-menu
            class="el-menu-vertical-demo bg-tran"
            :default-active="default_active1"
            text-color="#333333" active-text-color="#333333" :router="true"
            @select="change1"
          >
            <el-menu-item
              class="liBox bdb-w" :class="default_active1==item.path?'showLi':''"
              v-for="(item,index) in about" :key="index"
              :index="item.path"
            >
              <div class="pl40 h-per100 row a-center" slot="title">
                <img class="w6" :src="$getAssetUrl('/pcImgs/custom-right.png')"/>
                <div class="ml12 text-wrap" :class="la?'li_text1':'li_text2'">
                  {{item.name}}
                </div>
              </div>
            </el-menu-item>
          </el-menu>
        </div>
      </div>

      <!-- 产品中心 -->
      
      <!-- 工厂展示 -->
      <div class="w360 px10 pt24 pb25" v-else-if="current==3">
        <div class="ft24 c-w font-Bold">
          {{ $t('工厂展示') }}
        </div>
        <div class="mt18">
          <el-menu
            class="el-menu-vertical-demo bg-tran"
            :default-active="default_active3"
            text-color="#333333" active-text-color="#333333" :router="true"
            @select="change3"
          >
            <el-menu-item
              class="liBox" :class="default_active3==item.path?'showLi':''"
              v-for="(item,index) in factory" :key="index"
              :index="item.path"
            >
              <div class="pl40 h-per100 row a-center" slot="title">
                <img class="w6" :src="$getAssetUrl('/pcImgs/custom-right.png')"/>
                <div class="ml12 text-wrap" :class="la?'li_text1':'li_text2'">
                  {{item.name}}
                </div>
              </div>
            </el-menu-item>
          </el-menu>
        </div>
      </div>

      <!-- 销售网络 -->
      <div class="w360 px10 pt24 pb25" v-else-if="current==4">
        <div class="ft24 c-w font-Bold">
          {{ $t('销售网络') }}
        </div>
        <div class="mt18">
          <el-menu
            class="el-menu-vertical-demo bg-tran"
            :default-active="default_active4"
            text-color="#333333" active-text-color="#333333" :router="true"
            @select="change4"
          >
            <el-menu-item
              class="liBox" :class="default_active4==item.path?'showLi':''"
              v-for="(item,index) in network" :key="index"
              :index="item.path"
            >
              <div class="pl40 h-per100 row a-center" slot="title">
                <img class="w6" :src="$getAssetUrl('/pcImgs/custom-right.png')"/>
                <div class="ml12 text-wrap" :class="la?'li_text1':'li_text2'">
                  {{item.name}}
                </div>
              </div>
            </el-menu-item>
          </el-menu>
        </div>
      </div>

      <!-- 服务支持 -->
      <div class="w360 px10 pt24 pb25" v-else-if="current==5">
        <div class="ft24 c-w font-Bold">
          {{ $t('服务支持') }}
        </div>
        <div class="mt18">
          <el-menu
            class="el-menu-vertical-demo bg-tran"
            :default-active="default_active5"
            text-color="#333333" active-text-color="#333333" :router="true"
            @select="change5"
          >
            <el-menu-item
              class="liBox" :class="default_active5==item.path?'showLi':''"
              v-for="(item,index) in service" :key="index"
              :index="item.path"
            >
              <div class="pl40 h-per100 row a-center" slot="title">
                <img class="w6" :src="$getAssetUrl('/pcImgs/custom-right.png')"/>
                <div class="ml12 text-wrap" :class="la?'li_text1':'li_text2'">
                  {{item.name}}
                </div>
              </div>
            </el-menu-item>
          </el-menu>
        </div>
      </div>

      <!-- 新闻动态 -->
      <div class="w360 px10 pt24 pb25" v-else-if="current==6">
        <div class="ft24 c-w font-Bold">
          {{ $t('新闻动态') }}
        </div>
        <div class="mt18">
          <el-menu
            class="el-menu-vertical-demo bg-tran"
            :default-active="default_active6"
            text-color="#333333" active-text-color="#333333" :router="false"
            @select="change6"
          >
            <el-menu-item
              class="liBox bdb-w" :class="default_active6==String(index)?'showLi':''"
              v-for="(item,index) in news" :key="index"
              :index="String(index)"
            >
              <div class="pl40 h-per100 row a-center" slot="title">
                <img class="w6" :src="$getAssetUrl('/pcImgs/custom-right.png')"/>
                <div class="ml12 text-wrap" :class="la?'li_text1':'li_text2'">
                  {{item.name}}
                </div>
              </div>
            </el-menu-item>
          </el-menu>
        </div>
      </div>

      <!-- 联系我们 -->
      <div class="w360 px10 pt24 pb25" v-else-if="current==7">
        <div class="ft24 c-w font-Bold">
          {{ $t('联系我们') }}
        </div>
        <div class="mt18">
          <el-menu
            class="el-menu-vertical-demo bg-tran"
            :default-active="default_active7"
            text-color="#333333" active-text-color="#333333" :router="true"
            @select="change7"
          >
            <el-menu-item
              class="liBox" :class="default_active7==item.path?'showLi':''"
              v-for="(item,index) in contact" :key="index"
              :index="item.path"
            >
              <div class="pl40 h-per100 row a-center" slot="title">
                <img class="w6" :src="$getAssetUrl('/pcImgs/custom-right.png')"/>
                <div class="ml12 text-wrap" :class="la?'li_text1':'li_text2'">
                  {{item.name}}
                </div>
              </div>
            </el-menu-item>
          </el-menu>
        </div>
      </div>

    </el-aside>
  </div>
</template>

<script>
import { getNewsClass } from "@/api/app";
export default {
  name: '',
  props: {
    current: Number,
    class_id: Number,
  },
  components: {

  },
  data() {
    return {
      la:window.localStorage.getItem('language')=='en',
      default_active1:'Intro',//关于我们
      about:[
        {name:this.$t('企业简介'),path:'Intro',},
        {name:this.$t('企业文化'),path:'Culture',},
        {name:this.$t('员工风采'),path:'Staff',},
      ],
      default_active3:'Factory',
      factory:[
        {name:this.$t('工厂风采'),path:'Factory',},
      ],
      default_active4:'Network',
      network:[
        {name:this.$t('销售网络'),path:'Network',},
      ],
      default_active5:'Network',
      service:[
        {name:this.$t('服务支持'),path:'Service',},
      ],
      default_active6:'0',
      news:[ {} ],
      default_active7:'Contact',
      contact:[
        {name:this.$t('联系我们'),path:'Contact',},
      ]
    }
  },
  mounted() {
    let currentPath = this.$route.path;
    let t = this.$route.query.t || '';
    // console.log(this.current,currentPath); // 输出当前页面的路径部分
    // console.log(t);
    switch (this.current){
      case 1:
        this.default_active1 = currentPath.includes('Preview')?'Staff':currentPath.slice(1);
        break;
      case 3:
        this.default_active3 = currentPath.includes('Preview')?'Factory':currentPath.slice(1);
        break;
      case 4:
        this.default_active4 = currentPath.slice(1);
        break;
      case 5:
        this.default_active5 = currentPath.slice(1);
        break;
      case 6:
        this._getClass();
        break;
      case 7:
        this.default_active7 = currentPath.slice(1);
        break;
      default:
        break;
    }
  },
  methods: {
    // 分类
    async _getClass(){
      let {data} = await getNewsClass();
      if(data.code == 1){
        console.log(data.data);
        let list = data.data;
        this.news = list.map(item=>{
          return {
            name:item.name,
            path:'Enterprise',
          }
        });

        let currentPath = this.$route.path;
        let t = this.$route.query.t || '0';
        if(currentPath.includes('NDetail')){
          this.default_active6 = t;
        }else{
          console.log(currentPath,t);
          this.default_active6 = t?t:'0';
        }
      }else{
        this.$message.error(data.msg);
      }
    },
    change7(e){
      this.default_active7 = e;
    },
    change6(e){
      this.default_active6 = String(e);
      console.log(e);
      let currentPath = this.$route.path;
      let t = this.$route.query.t || '0';
      if(currentPath.includes('NDetail')){
        this.$router.push({
          path:'Enterprise?t='+e,
        })
      }else{
        console.log(currentPath,t);
        this.$router.push({
          path:'Enterprise?t='+e,
        })
        window.location.reload();
      }
    },
    change5(e){
      this.default_active5 = e;
    },
    change4(e){
      this.default_active4 = e;
    },
    change3(e){
      this.default_active3 = e;
    },
    change1(e){
      // console.log(e);
      this.default_active1 = e;
    },
  }
}
</script>

<style scoped lang='scss'>
.liBox{
  background-color: #F0F0F0;
  padding: 0 1.0417vw !important;
  padding-left: 2.0833vw !important;
  font-size: 15px;
  line-height: normal;
  height: 40px;
  .li_text1{
    font-size: 12px;
  }
  .li_text2{
    font-size: 15px;
  }
}
.liBox:hover{
  background-color: #A3F1C3;
}
.showLi{
  background-color: #A3F1C3;
}
@media screen and (min-width: 750px) and (max-width: 1250px){
.liBox{
  padding: 0 1.0417vw !important;
  padding-left: 2.0833vw !important;
  font-size: 10px;
  line-height: normal;
  height: 24px;
  .li_text1{
    font-size: 8px;
  }
  .li_text2{
    font-size: 10px;
  }
}
}
@media screen and (max-width: 750px){
.w6{width: 3px;}
.liBox{
  padding: 0 1.0417vw !important;
  padding-left: 2.0833vw !important;
  font-size: 6px;
  line-height: normal;
  height: 14px;
  .li_text1{
    font-size: 4px;
  }
  .li_text2{
    font-size: 6px;
  }
}
}
</style>